customElements.whenDefined('facets-drawer').then(() => {
  const panel = document.getElementById('facets-drawer');
  if (!panel) return;
  const listing = document.querySelector('.shopify-section--main-collection, .shopify-section--main-search');
  const section = panel.closest('.shopify-section') || document.querySelector('.shopify-section--filter-panel');
  const form = panel.querySelector('facets-form');
  if (listing && form) form.setAttribute('section-id', listing.id.replace(/^shopify-section-/, ''));
  ['submit', 'reset', 'facet:update'].forEach((type) => panel.removeEventListener(type, panel.hide));
  panel.addEventListener('dialog:after-hide', () => {
    const trigger = [...document.querySelectorAll('[aria-controls="facets-drawer"]')]
      .find((button) => button.getClientRects().length > 0);
    trigger?.focus({ preventScroll: true });
  });

  if (!listing || !section) return;
  const listingId = listing.id.replace(/^shopify-section-/, '');
  const panelId = section.id.replace(/^shopify-section-/, '');
  let request;
  document.addEventListener('facet:update', async (event) => {
    if (event.detail.url.searchParams.get('section_id') !== listingId) return;
    request?.abort();
    const currentRequest = request = new AbortController();
    const url = new URL(event.detail.url);
    url.searchParams.set('section_id', panelId);
    try {
      // The overlay is a separate section: replacing the listing cannot refresh its inputs.
      const response = await fetch(url, { signal: currentRequest.signal });
      if (!response.ok) return;
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextPanel = documentFragment.getElementById('facets-drawer');
      if (currentRequest.signal.aborted || !panel.isConnected || !nextPanel) return;
      const currentForm = panel.querySelector('facets-form');
      const nextForm = nextPanel.querySelector('facets-form');
      if (!currentForm || !nextForm) return;
      const groupKey = details => [...new Set([...details.querySelectorAll('input[name]')].map(input => input.name))].join('|');
      const openGroups = new Set([...panel.querySelectorAll('details[open]')].map(groupKey));
      nextPanel.querySelectorAll('details').forEach(details => details.toggleAttribute('open', openGroups.has(groupKey(details))));
      nextForm.setAttribute('section-id', listingId);
      const focusedId = panel.contains(document.activeElement) ? document.activeElement.id : null;
      // Keep the drawer header and its generated accessible-name target intact.
      currentForm.replaceWith(document.importNode(nextForm, true));
      if (focusedId) panel.querySelector(`#${CSS.escape(focusedId)}`)?.focus({ preventScroll: true });
    } catch (error) {
      // Keep the usable panel when a superseded request or a temporary network error interrupts it.
    }
  });
});
